import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class SpaceDetailModel extends ModeModelBase {
  override _name = 'spaceDetail';
  override belongsTo = 'space';
  override parentIdAttribute = 'token';
  override attributes = [
    { name: 'member_count', default: '' },
    { name: 'report_count', default: '' },
    { name: 'dataset_report_count', default: '' },
  ];
  override hasOne = [{ name: 'space', idAttribute: 'token' }];
}

@Injectable({ providedIn: 'root' })
export class SpaceDetailModelAccessor extends ModelAccessorBase<SpaceDetailModel> {
  override name = 'spaceDetail';
  override parentModel = 'space';
  override parentIdAttribute = 'token';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.spaceDetail');
  }

  createModel(resource, opts?) {
    const model = new SpaceDetailModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
